import { getCanonicalPostUrl } from '@wix/communities-blog-client-common';

export const getTagListItems = (posts, postPageSectionUrl, multilingual) =>
  posts.map(
    (post) =>
      `${getCanonicalPostUrl({ post, postPageSectionUrl, multilingual })}/`,
  );
